import {h} from 'ui/Framework';

export default h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '18',
  height: '18',
  viewBox: '-1 -1 20 20'
}, [
  h('path', {
    fill: '#0EB87F',
    d: 'M9 1.5C4.9 1.5 1.5 4.9 1.5 9s3.4 7.5 7.5 7.5 7.5-3.4 7.5-7.5S13.1 1.5 9 1.5zM9 15c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6zm2.6-6.8c.6 0 1.1-.5 1.1-1.1S12.2 6 11.6 6s-1.1.5-1.1 1.1.5 1.1 1.1 1.1zm-5.2 0c.6 0 1.1-.5 1.1-1.1S7 6 6.4 6s-1.2.5-1.2 1.1.6 1.1 1.2 1.1zM9 13.1c1.7 0 3.2-1.1 3.8-2.6H5.2c.6 1.5 2.1 2.6 3.8 2.6z'
  })
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/note-success.es6.js